/**
 * `commands.ts` — the CAD surface's cross-plugin command handles (#1527).
 *
 * These live HERE, not in `@ubiclouds/v5-workbench`, on purpose. The bus is
 * generic platform machinery; the vocabulary is CAD's. Declaring
 * `cad.loadDocument` beside `CadModel` keeps the payload type-checked end to end
 * without teaching the platform tier what a CAD document is — and the kernel is
 * a package both the CAD surface and its callers already depend on, so it is the
 * natural shared home.
 *
 * @module @ubiclouds/v5-cad-kernel/commands
 */

import { defineSurfaceCommand } from '@ubiclouds/v5-workbench/surface-commands';
import type { CadModel } from './cad-model.js';

/**
 * Load a fully-built model into the CAD surface, replacing what is open.
 *
 * The CAD surface REGISTERS this; anyone holding a `CadModel` invokes it. The
 * worked case is the home-battery rack projection, which used to import the CAD
 * store directly to make exactly this call. `invokeSurfaceCommand` returns false
 * when the CAD surface is not mounted, which is a normal state the caller handles
 * rather than an error.
 */
export const CAD_LOAD_DOCUMENT = defineSurfaceCommand<CadModel>('cad.loadDocument');
